import React from 'react';
import { useTranslation } from 'react-i18next';
import { Save, Loader2, AlertCircle } from 'lucide-react';

export default function SettingsHeader({ onSave, saving, hasUnsavedChanges }) {
  const { t } = useTranslation();

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              {t('settings.title')}
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              {t('settings.subtitle')}
            </p>
          </div>
          
          <div className="flex items-center gap-4">
            {hasUnsavedChanges && (
              <div className="flex items-center text-amber-600 bg-amber-50 px-3 py-2 rounded-lg border border-amber-200">
                <AlertCircle className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">
                  {t('settings.unsavedChanges')}
                </span>
              </div>
            )}
            
            <button 
              onClick={onSave}
              disabled={saving}
              className={`
                inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg
                shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                transition-all duration-200
                ${saving 
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                  : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-95'
                }
              `}
            >
              {saving ? (
                <>
                  <Loader2 className="animate-spin mr-2 h-4 w-4" />
                  {t('settings.saving')}
                </>
              ) : (
                <>
                  <Save className="mr-2 h-4 w-4" />
                  {t('settings.save')}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
